// extracted by mini-css-extract-plugin
module.exports = {"reportList":"plagiarism-checker_reportList__EQbkt","reportListItem":"plagiarism-checker_reportListItem__f6MT1","alertCount":"plagiarism-checker_alertCount__WfzS_"};